import { render, staticRenderFns } from "./Cotizacion.vue?vue&type=template&id=24a5b3b4"
import script from "./Cotizacion.vue?vue&type=script&lang=js"
export * from "./Cotizacion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24a5b3b4')) {
      api.createRecord('24a5b3b4', component.options)
    } else {
      api.reload('24a5b3b4', component.options)
    }
    module.hot.accept("./Cotizacion.vue?vue&type=template&id=24a5b3b4", function () {
      api.rerender('24a5b3b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clients/procesos/formalizacionactas/cotizacion/Cotizacion.vue"
export default component.exports